<template>
  <!-- D: 마이룸 그룹 페이지 -->
  <div
    class="p-order-wrap"
    style="margin-top: 12px"
    v-if="initData.list.orderableBasketListCount > 0"
  >
    <section
      class="basket-list-box"
      v-if="initData.list.orderableBasketListCount > 0"
    >
      <div
        class="c-order-control-box flex-ar"
        v-if="initData.list.orderableBasketListCount > 20"
      >
        <div class="right-box">
          <button
            type="button"
            class="c-util-button type-line-black"
            @click="itemMove"
          >
            <span>이동하기</span>
          </button>
          <button
            type="button"
            class="c-util-button type-line-black"
            @click="orderStop()"
          >
            <span>선택제품 주문하기</span>
          </button>
          <button
            type="button"
            class="c-util-button type-primary"
            @click="orderStop()"
          >
            <span>전체제품 주문하기</span>
          </button>
        </div>
      </div>

      <div class="c-order-control-box">
        <div class="left-box">
          <div class="c-checkbox type-small">
            <input
              type="checkbox"
              id="all-basket-chk1"
              name="basket-group1"
              v-model="allChecked"
            />
            <label for="all-basket-chk1">전체선택</label>
          </div>
          <button
            type="button"
            class="btn-selected-delete"
            @click="deleteCheckedItems()"
          >
            <i class="c-icon icon-check"></i>
            <span>선택삭제</span>
          </button>
        </div>
      </div>

      <!-- D: total&sorting -->
      <div class="c-sorting-wrap">
        <em class="total"
          >총:
          <span class="system">{{
            initData.list.orderableBasketListCount
          }}</span
          >개
        </em>
      </div>

      <!-- D: product compentnt -->
      <div class="c-products">
        <!-- D: 서브 전용 상품 컴포넌트 -->
        <!-- 상단 메뉴 -->
        <div class="top-menu">
          <div class="menu-item menu-item-3">상세정보</div>
          <div class="menu-item menu-item-4">가격</div>
        </div>
      </div>

      <!-- D: PC 전용 -->
      <div class="scroll-x only-pc-widh">
        <div class="scroll-x scroll-x-inner">
          <template v-if="checkedItems.length > 0">
            <BasketOrderableRow
              v-for="(item, index) in initData.list.orderableBasketList"
              :key="item.cartSn"
              :index="index"
              :item="item"
              :checked="checkedItems[index]?.checked"
              :werks="initData.codes.CODE_WERKS"
              @checked="(checked) => handleCheck(index, checked)"
              @detail="(item) => openProdInfoPop(item)"
              @ordertemp="() => orderStop()"
              @buy="(product) => props.orderSheet.addItemList(product)"
              @cart="(product) => addCartItem(product)"
            />
          </template>
        </div>
      </div>

      <div class="c-order-control-box flex-ar">
        <div class="right-box order-pc-pr">
          <button
            type="button"
            class="c-util-button type-line-black"
            @click="itemMove"
            style="float: left"
          >
            <span>이동하기</span>
          </button>
          <button
            type="button"
            class="c-util-button type-line-black"
            @click="orderStop()"
          >
            <span>선택제품 주문하기</span>
          </button>
          <button
            type="button"
            class="c-util-button type-primary"
            @click="orderStop()"
          >
            <span>전체제품 주문하기</span>
          </button>
        </div>
      </div>
    </section>

    <!-- D: MO 전용 -->
    <div class="c-btn-area type-full is-fixed" data-bottom-fixed>
      <button
        type="button"
        class="c-button type-small type-primary"
        @click="orderStop()"
      >
        <span
          >주문하기 ({{ totalCount }}개
          {{ Number(totalPrice).toLocaleString() }}원)</span
        >
      </button>
    </div>
    <!-- // D: MO 전용 -->
  </div>

  <!-- D: 마이룸 그룹(제품無) 페이지 -->
  <div
    v-if="
      initData.page.hasNodata &&
      initData.list.orderableBasketListCount == 0 &&
      props.groupSn
    "
    class="c-no-data-box"
  >
    <div class="icon-box">
      <i class="c-icon icon-nodata size-large"></i>
    </div>
    <p class="text">마이룸 그룹에 담긴 제품이 없습니다.</p>
  </div>
  <div v-if="!props.groupSn" class="c-no-data-box">
    <div class="icon-box">
      <i class="c-icon icon-nodata size-large"></i>
    </div>
    <p class="text">선택된 마이룸 그룹이 존재하지 않습니다.</p>
  </div>

  <ProdInfoPop
    v-if="isShowProdInfoPop"
    v-bind="prodInfoPopProps"
    @close="() => (isShowProdInfoPop = false)"
  />

  <GroupItemMovePop
    v-if="initData.popup.isShowGroupInfoPop"
    :checkedItems="initData.checkedGoods"
    :groupSn="props.groupSn"
    @group-update="getBasketList"
    @close="() => (initData.popup.isShowGroupInfoPop = false)"
  />
</template>
<script setup name="basket">
//const { isMobile } = cmUtil.useDeviceType();
import { useAuthStore } from "@/store";
import { getLocalStorage } from "@/utils/cmUtil";
import {
  computed,
  inject,
  onMounted,
  provide,
  reactive,
  readonly,
  ref,
  watch,
  defineProps,
} from "vue";
import { api } from "@/plugins/api";
//import router from "@/router";
import BasketOrderableRow from "@/components/paintpro/myRoom/basketOrderableRow.vue";
import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";
import GroupItemMovePop from "@/components/paintpro/myRoom/myRoomGroupItemMove.vue";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import * as store from "@/store";
import * as orderApi from "@/api/orderApi.js";
import { useRoute } from "vue-router";
import utils from "@/js/utils";

const url = inject("url_prefix");
const authStore = useAuthStore();
const route = useRoute();
const props = defineProps({
  groupSn: {
    type: Number,
    require: true,
  },
  tabIndex: {
    type: Number,
    require: true,
  },
  orderSheet: {
    type: Object,
    required: true,
  },
});

const initData = reactive({
  page: {
    isLogin: false,
    userLoginInfo: {},
    basketCount: {},
    path: "",
    isPageInit: false,
    hasNodata: false,
  },
  codes: {
    CODE_WERKS: [],
    CODE_GOODS_FILE_SE_CD: [],
  },
  popup: {
    isShowProdInfoPop: false, // 제품상세
    isShowGroupInfoPop: false, //제품이동
  },
  list: {
    orderableBasketListCount: 0, // 주문가능제품 개수
    orderableBasketList: [], // 주문가능제품
    fashionItemList: [], // 인기제품
  },
  eventBus: {
    salesPersonIndex: 0,
  },
  checkedGoods: [],
});

const checkedItems = ref([]); // 체크된 아이템 관리
const allChecked = computed({
  get: () => {
    if (checkedItems.value.length === 0) {
      return false; // 리스트가 비어있을 때는 전체선택 체크박스를 false로 설정
    }
    return checkedItems.value.every((item) => item.checked);
  }, // 전체선택 체크박스 값
  set: (value) =>
    (checkedItems.value = checkedItems.value.map((item) => ({
      ...item,
      checked: value,
    }))),
}); // 체크박스 전체선택

const noExistChecked = computed(() =>
  checkedItems.value.every((item) => item.checked === false)
);

const totalPrice = computed(() =>
  checkedItems.value
    .filter((item) => item.checked)
    .reduce((sum, item) => {
      return sum + item.kbetr * item.goodsQty;
    }, 0)
); // 총 가격
const totalCount = computed(
  () => checkedItems.value.filter((item) => item.checked).length
);

const prodInfoPopProps = ref({
  matnr: null,
}); // 제품상세팝업
const isShowProdInfoPop = ref(false);
const selectedBranch = ref(null);

provide("CODE_WERKS", readonly(initData.codes.CODE_WERKS));
provide(
  "CODE_GOODS_FILE_SE_CD",
  readonly(initData.codes.CODE_GOODS_FILE_SE_CD)
);

onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

async function pageInit() {
  await pageInitData();
  searchCmd();
}

async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  mparm.push({ qId: "cmCode_code1", parm: { cdGrp: "WERKS" } });
  mparm.push({ qId: "cmCode_code2", parm: { cdGrp: "GOODS_FILE_SE_CD" } });

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    return false;
  }

  initData.page.path = route.path;
  initData.page.token = getLocalStorage("token");
  initData.page.isLogin = authStore?.user ? true : false;
  initData.page.userLoginInfo = authStore?.user;
  initData.codes.CODE_WERKS = res.data.cmCode_code1;
  initData.codes.CODE_GOODS_FILE_SE_CD = res.data.cmCode_code2;

  // 영업사원 디폴트
  initData.eventBus.salesPersonIndex =
    store.useEventBusStore()?.salesPersonIndex;
  selectedBranch.value =
    initData.page.userLoginInfo.empList[initData.eventBus.salesPersonIndex];
}

async function searchCmd() {
  getBasketList(); // 마이룸 그룹
  initData.page.isPageInit = true;
}

//이동하기
async function itemMove() {
  initData.checkedGoods = checkedItems.value
    .filter((item) => item.checked)
    .map((item) => item.goodsSn);

  if (initData.checkedGoods.length < 1) {
    await cmUtil.alert("제품을 선택해주세요.");
    return;
  }

  initData.popup.isShowGroupInfoPop = true;
}

async function orderStop() {
  cmUtil.alert("[페인트프로 주문 일시 중단]<br><br>원료 수급 이슈로 온라인 주문이 일시 중단되었습니다.<br>관련 문의는 담당 영업사원에게 연락 부탁드립니다.");
  return;
}

// 주문하기
// async function orderNow(itemParam, flag) {
//   const item = itemParam;
//   const params = {
//     masterData: {},
//     detailList: [{}],
//   };
//   params.masterData.orderTmpStatusCd = 1; // 임시주문상태코드 - 1:주문대기, 2:주문완료
//   params.masterData.zempNo = selectedBranch.value?.kunn2; // 직원사번
//   params.masterData.dmndScrnPath = initData.page.path; // 임시주문 호출경로

//   if (flag == "alone") {
//     if (itemParam.zzlqdCls === "A") {
//       const res = await orderApi.checkSetProduct(item.goodsSn);
//       if (res.set) {
//         params.detailList[0].goodsSn = res.goodsSn;
//         params.detailList[0].goodsQty = itemParam.goodsQty || 1;
//       } else {
//         params.detailList[0] = item;
//       }
//     } else {
//       params.detailList[0] = item;
//     }
//   } else if (flag == "checked") {
//     if (noExistChecked.value) {
//       await cmUtil.alert("제품을 선택해주세요.");
//       return;
//     }
//     const checkedGoods = checkedItems.value
//       .filter((item) => item.checked)
//       .map((item) => item.goodsSn);
//     params.detailList = initData.list.orderableBasketList
//       .filter((item) => checkedGoods.includes(item.goodsSn))
//       .map((item) => ({ ...item, quantity: item.goodsQty }));
//   } else if (flag == "all") {
//     params.detailList = initData.list.orderableBasketList.map((item) => ({
//       ...item,
//       quantity: item.goodsQty,
//     }));
//   }

//   for (var itemInfo in params.detailList) {
//     console.log(params.detailList[itemInfo]);
//     if (params.detailList[itemInfo].mmsta == "99") {
//       await cmUtil.alert(
//         "제품코드:" +
//           params.detailList[itemInfo].matnr +
//           "는 판매종료된 상품입니다. (주문불가)"
//       );
//       return;
//     }
//     if (params.detailList[itemInfo].zzprdTyp == "A") {
//       await cmUtil.alert(
//         "제품코드:" +
//           params.detailList[itemInfo].matnr +
//           "는 주문상품 입니다.(주문불가)"
//       );
//       return;
//     }
//   }

//   if (isMobile.value) {
//     const res = await api.post(`${url}/order/saveOrderTemp`, params);
//     if (res.resultCode === 200) {
//       const orderTmpSn = res.data;
//       router.push({
//         path: "/paintpro/orderOrder",
//         query: { orderTmpSn: orderTmpSn },
//       });
//     }
//   } else {
//     for (var i = 0; i < params.detailList.length; i++) {
//       props.orderSheet.addItemList(params.detailList[i]);
//     }
//   }

//   return;
// }

// 마이룸 그룹 리스트
async function getBasketList() {
  let paramMap = {
    groupSn: props.groupSn,
  };

  if (utils.isBlank(props.groupSn)) {
    initData.list.orderableBasketListCount = 0;
    initData.list.orderableBasketList = [];
    return;
  }

  cmUtil.loading("", { duration: 60000 });

  const res = await api.post(`${url}/basket/getMyRoomList`, paramMap);
  initData.list.orderableBasketListCount = res.data.orderableBasketListCount;
  initData.list.orderableBasketList = res.data.orderableBasketList;

  cmUtil.loadingHide();

  // 체스리스트
  checkedItems.value = initData.list.orderableBasketList.map((item) => ({
    itemSn: item.cartSn,
    groupSn: item.groupSn,
    orderTmpSn: item.orderTmpSn,
    orderDtlTmpSn: item.orderDtlTmpSn,
    goodsSn: item.goodsSn,
    goodsQty: item.goodsQty,
    kbetr: item.kbetr,
    checked: false,
  }));

  if (initData.list.orderableBasketListCount > 0) {
    initData.page.hasNodata = false;
  } else {
    initData.page.hasNodata = true;
  }
}

// 상세팝업에서 마이룸 그룹 담기
const addCartItem = async (param = { product: null, quantity: 0 }) => {
  const res = await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    goodsQty: param.quantity,
    vwerk: initData.page.userLoginInfo.vwerk,
    zzlqdCls: param.product.zzlqdCls,
  });

  if (res.resultCode === 200) {
    // 정상적으로 등록되었을 경우
    await getBasketList();
  }
};
provide("addCartItem", addCartItem);

// 상세팝업에서 바로주문
const addBuyItem = async (product) => {
  const param = {
    goodsSn: product.goodsSn,
    goodsQty: product.quantity,
    zempNo: selectedBranch.value.kunn2,
    path: initData.page.path,
  };
  await orderApi.createTempOrder(param);
};
provide("addBuyItem", addBuyItem);

// 인기제품에서 마이룸 그룹 담기
const addCartItemFromFashion = async (
  param = { product: null, quantity: 1 }
) => {
  const res = await cmApi.insertUserBasketProd({
    goodsSn: param.product.goodsSn,
    goodsQty: param.quantity,
    vwerk: initData.page.userLoginInfo.vwerk,
    zzlqdCls: param.product.zzlqdCls,
  });
  if (res.resultCode === 200) {
    await getBasketList();
  }
};
provide("addCartItemFromFashion", addCartItemFromFashion);

// 선택삭제
async function deleteCheckedItems() {
  if (noExistChecked.value) {
    await cmUtil.alert("제품을 선택해주세요.");
    return;
  }
  if (allChecked.value == true) {
    if (
      !(await cmUtil.confirm(
        "마이룸 그룹에 담은<br> 전체 제품을<br>삭제하시겠습니까?"
      ))
    ) {
      return;
    }
  }
  const deleteItemList = checkedItems.value.filter(
    (item) => item.checked === true
  );
  const res = await deleteUserBasketProds(deleteItemList);
  deleteItemList.map((item) => item.goodsSn);
  if (res.resultCode === 200) {
    await getBasketList();
    await cmUtil.alert("삭제되었습니다.");
  }
}

async function deleteUserBasketProds(parm = []) {
  let validItems = [{ name: "goodsSn", title: "상품번호" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    parm.forEach((item) => {
      if (item[validItems[i].name] == null || item[validItems[i].name] == "") {
        validMsg += `${validItems[i].title} 정보가 없습니다.`;
      }
    });
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/myRoom/deleteUserBasketProds`, parm);

  return res;
}

// 제품 상세 팝업
function openProdInfoPop(item) {
  prodInfoPopProps.value.matnr = item.matnr;
  isShowProdInfoPop.value = true;
}

// ROW 체크박스
function handleCheck(index, checked) {
  checkedItems.value[index].checked = checked;
}

// 헤더 영업사원 콤보박스
watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    if (
      newValue >= 0 &&
      initData.page.userLoginInfo?.empList?.length > newValue
    ) {
      selectedBranch.value = initData.page.userLoginInfo.empList[newValue];
    }
  }
);

watch(
  () => props.tabIndex,
  (newValue) => {
    if (newValue == 1) {
      getBasketList();
    }
  }
);

watch(
  () => props.groupSn,
  () => {
    getBasketList();
  }
);
</script>
